import React from "react";
import "./ColumnColors.scss";

const loaiKCBColors = {
  "Khám mới": {
    color: "#00b335",
    label: "New",
  },
  "Khám lại": {
    color: "rgb(181 181 181)",
    label: "Review",
  },
  "Tái khám": {
    color: "rgb(181 181 181)",
    label: "Review",
  },
  "Tái khám sau PT": {
    color: "#FF33AC",
    label: "Post OP",
  },
  "Tái khám sau PT (1 ngày)": {
    color: "#FF33AC",
    label: "Post OP",
  },
  "Phẫu thuật": {
    color: "rgb(210 127 127)",
    label: "Investigation",
  },
  "Cấp cứu": {
    label: "Emrgency",
    color: "#FF0000",
  },
  "Khám đoàn": {
    label: "Free Camp",
  },
  "Khám vip": {
    label: "Vip",
    color: "#ffa500",
  },
  Tiêm: {
    color: "rgb(210 137 137)",
    label: "Tiêm",
  },
  "Tái khám ngoại trú đặt lịch": {
    color: "rgb(210 137 137)",
    label: "Tái khám ngoại trú đặt lịch",
  },
};

const KCBTypeColumn = ({label}: {label: string}) => {
  return (
    <div
      className="color-column"
      style={{
        backgroundColor: label
          ? loaiKCBColors?.[label]?.color ?? "rgb(210 127 127)"
          : "",
        textAlign: "center",
      }}
    >
      {label}
    </div>
  );
};

export default KCBTypeColumn;
